import PriceWrapper from "../../../containers/price-wrapper";
import PropTypes from "prop-types";
import React from "react";
import { showRentalPrices } from "../../shared/util";
import DropdownList from "../../shared/dropdown-list/dropdown-list";

const Price = ({ listing, showRentalsTermsInDropdown = false }) => {
  if (showRentalPrices(listing)) {
    const prices = listing.rentalPrices.map(function (price, index) {
      return (
        <PriceWrapper
          key={index}
          priceInt={price.priceInt}
          displayPrice={price.price}
          label={price.label}
          suffix={price.suffix}
          classes="price-item"
        />
      );
    });
    return showRentalsTermsInDropdown ? (
      <DropdownList items={prices} />
    ) : (
      <span>{prices}</span>
    );
  } else {
    let fees = null;
    if (listing.listingFees) {
      const listingFees = listing.listingFees.filter(
        (data) =>
          !data.prefix.toLowerCase().includes("buyer agency compensation")
      );
      fees = listingFees
        ? listingFees.map(function (fee, index) {
            return (
              <span key={index}>
                <PriceWrapper
                  priceInt={fee.priceInt}
                  displayPrice={fee.displayPrice}
                  prefix={fee.prefix}
                  classes="fee-item"
                />
              </span>
            );
          })
        : null;
    }
    return (
      <span>
        {fees}
        <PriceWrapper
          priceInt={listing.price}
          displayPrice={listing.displayPrice}
          classes="price-item"
        />
      </span>
    );
  }
};

Price.propTypes = {
  listing: PropTypes.object.isRequired,
  showRentalsTermsInDropdown: PropTypes.bool,
};

export default Price;



// WEBPACK FOOTER //
// ./src/components/search/result/price.jsx